/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_TitleInputs */

const en_home_hero_title = /** @type {(inputs: Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft: free, open-source CAD for people and AI agents`)
};

/**
* | output |
* | --- |
* | "CADCraft: free, open-source CAD for people and AI agents" |
*
* @param {Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_title = /** @type {((inputs?: Home_Hero_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_title(inputs)
});
export { home_hero_title as "home.hero.title" }